import { numberToPrettyString } from '@cian/utils';
import * as React from 'react';

import { useChangeValues } from './useChangeValues';

interface ICalculatorValues {
  apartmentPrice: string;
  percentageReward: string;
}

export const useCalculateReward = () => {
  const [reward, setReward] = React.useState<string>('1 000 000');
  const { values, setValue } = useChangeValues<ICalculatorValues>();

  const handleChangeApartmentPrice = React.useCallback(
    (value: string) => setValue('apartmentPrice', value),
    [setValue],
  );

  const handleChangePercentageReward = React.useCallback(
    (value: string) => {
      setValue('percentageReward', value);
    },
    [setValue],
  );

  const calculateReward = React.useCallback(() => {
    const { apartmentPrice, percentageReward } = values;

    if (apartmentPrice && percentageReward) {
      const result = Math.round((Number(apartmentPrice) * Number(percentageReward)) / 100);
      setReward(numberToPrettyString(result));
    } else {
      setReward('1 000 000');
    }
  }, [values]);

  React.useEffect(() => {
    calculateReward();
  }, [calculateReward]);

  return { reward, values, handleChangePercentageReward, handleChangeApartmentPrice };
};
